import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import './styles.css';

const NotFound = () => <h2 className="notFound">not found..</h2>;

export default withRouter(
  connect(
    null,
    null,
  )(NotFound),
);
